/**
 * Generated by orval v8.9.1 🍺
 * Do not edit manually.
 * htoken API
 * OpenAPI spec version: v1
 */
export const KycStartRequestDtoKycMethod = {
    WEBID: 'WEBID',
    WEBIDEID: 'WEBIDEID',
    WEBIDPAY: 'WEBIDPAY',
    CSIDENT: 'CSIDENT',
};
//# sourceMappingURL=kycStartRequestDtoKycMethod.js.map